export const LogoIcon = () => (
  <a href="/stories" aria-label="Yomimono home" className="shrink-0">
    <img src="/logo_full.svg" alt="yomimono" className="h-6" />
  </a>
)
